export const LOGO_PRIMARY = "https://customer-assets.emergentagent.com/job_sports-press-hub/artifacts/vvwjhg0c_1775762484499.png";
export const LOGO_HORIZONTAL = "https://customer-assets.emergentagent.com/job_sports-press-hub/artifacts/yswiahvn_1775764796316.png";
export const LOGO_NEON = "https://customer-assets.emergentagent.com/job_sports-press-hub/artifacts/hxyfq25u_1775019142438.png";
export const LOGO_VINTAGE = "https://customer-assets.emergentagent.com/job_sports-press-hub/artifacts/3wd8f6c1_1775016778791.png";
export const STUDIO_SHOT = "https://customer-assets.emergentagent.com/job_sports-press-hub/artifacts/dzdgeav1_1775034019010.png";

export const SOCIALS = [
  { key: "instagram", label: "Instagram", handle: "@Unfilteredandonball", url: "https://instagram.com/Unfilteredandonball", icon: "Instagram" },
  { key: "tiktok", label: "TikTok", handle: "@Unfilteredandonball", url: "https://tiktok.com/@Unfilteredandonball", icon: "Music2" },
  { key: "facebook", label: "Facebook", handle: "@Unfilteredandonball", url: "https://facebook.com/Unfilteredandonball", icon: "Facebook" },
  { key: "twitch", label: "Twitch", handle: "@Unfilteredandonball", url: "https://twitch.tv/Unfilteredandonball", icon: "Twitch" },
  { key: "youtube", label: "YouTube", handle: "@Unfilteredandonball", url: "https://youtube.com/@Unfilteredandonball", icon: "Youtube" },
  { key: "spotify", label: "Spotify", handle: "Unfiltered & On-Ball", url: "https://open.spotify.com/show/unfilteredandonball", icon: "Radio" },
];

export const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "football", label: "Football" },
  { key: "basketball", label: "Basketball" },
  { key: "draft", label: "Draft" },
  { key: "teams", label: "Teams" },
  { key: "news", label: "News" },
];

export const formatNumber = (n) => {
  if (n === null || n === undefined) return "10K+";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M+`;
  if (n >= 1_000) return `${Math.floor(n / 1_000)}K+`;
  return String(n);
};

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
